export default __webpack_public_path__ + "static/media/gothenburg_grid_xl.df651831.jpg";